// extracted by mini-css-extract-plugin
export default {"bannersContainer":"styles_bannersContainer__L1vqw","bannersControls":"styles_bannersControls__LA1MN","bannersControlsContainer":"styles_bannersControlsContainer__VFZcy"};